import type { UseQueryOptions } from 'react-query';

import {
  venueLeadsApiKeys,
  useVenueLeadsApi,
} from '../../../../hooks/api/venue-leads/useVenueLeadsApi';
import { useGetApi } from '../../../../hooks/api/useGetApi';
import type { VenueLeadTicket } from '../../../../types/events/venue-leads';

export function useVenueLeadsStatus(
  organizationId: string,
  options?: UseQueryOptions<VenueLeadTicket>
) {
  const api = useVenueLeadsApi();

  return useGetApi({
    enabled: !!organizationId,
    queryKey: venueLeadsApiKeys.isRunningTicket(organizationId),
    request: () => api.isRunningTicket(organizationId),
    ...options,
  });
}
